// @ts-nocheck
export default (callback: () => void, conditionalCallback?: () => boolean) => {
    const condition = conditionalCallback?.();

    if (condition === undefined) {
        return callback();
    }

    if (condition) {
        return callback();
    }
};
